import "@rmwc/icon/styles";
import { CollapsibleList, SimpleListItem } from "@rmwc/list";
import { Modale } from "App/Modale/Components/Modale";
import { URL } from "Login/API/LoginAPI";
import PropTypes from "prop-types";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import Slider from "react-slick";
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import "./DescriptifBorne.css";

const SLIDER_SETTINGS = {
  dots: true,
  infinite: false,
  slidesToShow: 3,
  autoplay: true,
  speed: 2000,
  autoplaySpeed: 5000,
  cssEase: "linear"
};

// #region FONCTION COMPOSANT
/**
* Composant permettant d'afficher le descriptif d'une borne dans l'écran d'achat
* @class
* @category DescriptifBorne
*/
function DescriptifBorne(props) {
  // #region INITIALISATION
  const {
    data,
    idSite
  } = props;

  const [selectImage, setSelectImage] = useState(null);
  const [ModaleDescriptionVisible, setModaleDescriptionVisible] = useState(false);
  
  // Traduction i18n
  const { t } = useTranslation();
  
  // Traduction du texte d'avertissement pour l'ID site 1854 uniquement
  const getTranslatedDescriptif = () => {
    if (!data.descriptif) return data.descriptif;
    
    // Pour l'ID site 1854, traduire le texte d'avertissement
    if (idSite === 1854) {
      const originalText = "ATTENTION : LES CAMPING-CARS DE PLUS DE 9M NE SONT PAS AUTORISES !";
      const translatedText = t("achat.campingCarWarning");
      
      // Remplacer le texte original par la traduction
      return data.descriptif.replace(originalText, translatedText);
    }
    
    // Pour les autres sites, retourner le descriptif tel quel
    return data.descriptif;
  };
  // #endregion

  // #region INTERFACE
  return (
    <div>
      {ModaleDescriptionVisible
        ?
        <Modale
          onClose={() => { setSelectImage(null); setModaleDescriptionVisible(false) }}
          visible={ModaleDescriptionVisible}
          width="350"
          height="350"
        >
          <img
            alt={t("achat.description")}
            src={selectImage}
            style={{ width: "350px", height: "350px" }}
          />
        </Modale>
        :
        null
      }
      <CollapsibleList
        defaultOpen
        handle={
          <SimpleListItem
            text={t("achat.description")}
            graphic="map"
            metaIcon="chevron_right"
          />
        }
      >
        <div className="DescriptifBorne-Container">
          <div className="DescriptifBorne-Text">
            {getTranslatedDescriptif()}
          </div>
          <div className="DescriptifBorne-Image-Container">
            <Slider {...SLIDER_SETTINGS}>
              {/* {Object.keys(data.images).forEach((image, index) => ( */}
              {data.images && data.images.map((image, index) => {
                const urlImage = URL + "/" + image;
                return (
                  <img
                    alt={image}
                    className="DescriptifBorne-Image"
                    key={index}
                    onClick={() => { setSelectImage(urlImage); setModaleDescriptionVisible(true) }}
                    src={urlImage}

                  />
                )
              })}
            </Slider>
          </div>
        </div >
      </CollapsibleList >

    </div >
  );
  // #endregion
};
// #endregion

// #region PROPRIETES
/**
* Type des propriétés de {@link DescriptifBorne}
* @typedef {Object} DescriptifBorne.propTypes
* @property {object} data Données de description d'une borne
*/
DescriptifBorne.propTypes = {
  data: PropTypes.object.isRequired,
  idSite: PropTypes.number
};
// #endregion

export { DescriptifBorne };

